define("ember-composable-helpers/helpers/noop", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.noop = noop;
  function noop() {
    return () => {};
  }
  var _default = _exports.default = (0, _helper.helper)(noop);
});